import { GetProcessChainTreeResponseSchema } from './get-process-chain-tree.schema';
// TODO: Review AI Code for feature: Process Map - Entire file is AI-generated
export const getProcessChainTreeContract = {
    method: 'GET',
    path: '/api/v2/process-chains/tree',
    description: 'Get hierarchical tree of all process chains grouped by category',
    responseSchema: GetProcessChainTreeResponseSchema,
    statusCodes: {
        success: 200,
        errors: {
            401: 'Unauthorized',
            403: 'Forbidden'
        }
    }
};

//# sourceMappingURL=get-process-chain-tree.contract.js.map